export const blurbs = [
  {
    icon: 'SNavHealthRecord',
    category: 'Health Records',
    description: 'View your test results and refill prescriptions'
  },
  {
    icon: 'SNavBilling',
    category: 'Billing',
    description: 'Pay your medical bills'
  },
  {
    icon: 'SNavMessages',
    category: 'Messaging',
    description: 'Message with your care providers'
  },
  {
    icon: 'SNavGetCare',
    category: 'Get Care',
    description: 'Find a provider, book an appointment, or launch an online visit'
  }
];
